import { useLogon } from '@core/Utils/hooks'
import React from 'react'
import { useLocation } from 'react-router'

type InterceptTypes = 'deposit' | 'bet' | 'bonus' | 'special'

declare global {
  interface Window {
    qualtricsIntercept?: InterceptTypes
    QSI?: {
      API: {
        run: () => void
      }
    }
  }
}

export const setQualtricsIntercept = (intercept?: InterceptTypes) => {
  window.qualtricsIntercept = intercept
}

export const useQualtricsInteceptor = () => {
  const { isLoggedIn } = useLogon()
  const location = useLocation()

  React.useEffect(() => {
    if (!isLoggedIn) setQualtricsIntercept(undefined)
  }, [isLoggedIn])

  React.useEffect(() => {
    // Only trigger intercept when navigating to home page
    if (location.pathname != '/') return

    setTimeout(() => {
      if (window.qualtricsIntercept && window.QSI) {
        window.QSI.API.run()
        setQualtricsIntercept(undefined)
      }
    }, 1000)
  }, [location])
}
